import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { ModalOpcaoContratoComponent } from '../modal-opcao-contrato/modal-opcao-contrato.component';
import { ModalService } from '../../services/modal.service';

@Component({
   selector: 'app-bairros-gallery',
   standalone: true,
   imports: [CommonModule],
   templateUrl: './bairros-gallery.component.html',
   styleUrl: './bairros-gallery.component.scss'
})
export class BairrosGalleryComponent {
   constructor(public router: Router, public modalService: ModalService) {}

   
      openModal(tipo: string) {
         this.modalService.open(ModalOpcaoContratoComponent, {
            tipo
         });
      }

}


